import { createStorage } from 'unstorage';
import memoryStorageDriver from "unstorage/drivers/memory";

export const catalogPagingStorageClient = createStorage({
  driver: memoryStorageDriver()
});
